import React from "react";
import { ReceiptCategory } from "../services/receipt-category-service";

interface ReceiptCategoryDetailProps {
  open: boolean;
  onClose: () => void;
  data?: ReceiptCategory | null;
}

export const ReceiptCategoryDetail: React.FC<ReceiptCategoryDetailProps> = ({
  open,
  onClose,
  data,
}) => {
  if (!open || !data) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 animate-fadeIn">
      <div className="bg-white rounded-2xl w-[520px] shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-green-500 text-white px-6 py-3 flex justify-between items-center">
          <h3 className="text-lg font-semibold">Chi tiết danh mục Thu Chi</h3>
          <button
            onClick={onClose}
            className="text-white text-2xl leading-none hover:opacity-80"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4 text-gray-800">
          {/* Mã danh mục */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Mã danh mục
            </p>
            <p className="text-base text-black">{data.code || "—"}</p>
          </div>

          {/* Tên danh mục */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Tên danh mục
            </p>
            <p className="text-base text-black">{data.name || "—"}</p>
          </div>

          {/* Loại phiếu */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Loại phiếu
            </p>
            <p
              className={`text-base ${
                data.type === 1 ? "text-green-700" : "text-red-700"
              }`}
            >
              {data.type === 1 ? "Phiếu Thu" : "Phiếu Chi"}
            </p>
          </div>

          {/* Trạng thái */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">
              Trạng thái
            </p>
            <p
              className={`text-base ${
                data.status === 1 ? "text-green-700" : "text-gray-700"
              }`}
            >
              {data.status === 1 ? "Hoạt động" : "Tạm ngưng"}
            </p>
          </div>

          {/* Mô tả */}
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-1">Mô tả</p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-base text-gray-800 min-h-[60px] whitespace-pre-line">
              {data.description || "Không có mô tả"}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-medium"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};
